import React from "react";
import "../styles/loader.css";
function Loading() {
	return (
		<div className="loader-container">
			<div className="loader-spinner"></div>
		</div>
	);
}

export { Loading };
